<script>

    import { orderLinkStore } from '../stores'
    import { createEventDispatcher } from 'svelte'

    import ZipcodeColonyComponent from '../locations/component.zipcode.colony.svelte'

    const dispatch = createEventDispatcher()
    
    export let delivery = {
        contact: '',
        corporate: '',
        phone: '',
        email: '',
        country: '',
        zipcode: '',
        state: '',
        city: '',
        municipality: '',
        colony: '',
        street: '',
        number: '',
        apartment: '',
        references: ''
    }

    let loading = false

    function onSelected() {
        dispatch('selected', delivery)
    }

</script>

{#if !loading && $orderLinkStore}
    <form on:submit|preventDefault={onSelected}>
        <div class="title"><b>Dirección de destino</b></div>
        <div class="is-divider"></div>
        <div class="columns">
            <div class="column">
                <div class="field">
                    <label for="" class="label">Contacto</label>
                    <div class="control has-icons-left">
                        <span class="icon"><i class="fas fa-user"></i></span>
                        <input bind:value={delivery.contact} type="text" class="input" placeholder="Contacto" required>
                    </div>
                </div>
            </div>
        </div>
        <div class="columns">
            <div class="column">
                <div class="field">
                    <label for="" class="label">RFC</label>
                    <div class="control has-icons-left">
                        <span class="icon"><i class="fas fa-building"></i></span>
                        <input bind:value={delivery.rfc} type="text" class="input" placeholder="RFC con homoclave" minlength="12" maxlength="13" required >
                    </div>
                </div>
            </div>
            <div class="column">
                <div class="field">
                    <label for="" class="label">Corporación</label>
                    <div class="control has-icons-left">
                        <span class="icon"><i class="fas fa-building"></i></span>
                        <input bind:value={delivery.corporate} type="text" class="input" placeholder="Corporación">
                    </div>
                </div>
            </div>
        </div>
        <div class="columns">
            <div class="column">
                <div class="field">
                    <label for="" class="label">Teléfono</label>
                    <div class="control has-icons-left">
                        <span class="icon"><i class="fas fa-phone"></i></span>
                        <input bind:value={delivery.phone} type="text" class="input" placeholder="Teléfono" required>
                    </div>
                </div>
            </div>
            <div class="column">
                <div class="field">
                    <label for="" class="label">Correo electrónico</label>
                    <div class="control has-icons-left">
                        <span class="icon"><i class="fas fa-envelope"></i></span>
                        <input bind:value={delivery.email} type="email" class="input" placeholder="Correo electrónico" required>
                    </div>
                </div>
            </div>
        </div>

        <ZipcodeColonyComponent  
            bind:zipcode={delivery.zipcode}
            bind:state={delivery.state}
            bind:city={delivery.city}
            bind:municipality={delivery.municipality}
            bind:colony={delivery.colony}
        />

        <div class="columns">
            <div class="column">
                <div class="field">
                    <label for="" class="label">Calle</label>
                    <div class="control has-icons-left">
                        <span class="icon"><i class="fas fa-map-marker-alt"></i></span>
                        <input bind:value={delivery.street} type="text" class="input" placeholder="Calle" required>
                    </div>
                </div>
            </div>
        </div>
        <div class="columns">
            <div class="column">
                <div class="field">
                    <label for="" class="label">Número exterior</label>
                    <div class="control has-icons-left">
                        <span class="icon"><i class="fas fa-hashtag"></i></span>
                        <input bind:value={delivery.number} type="text" class="input" placeholder="Número" required>
                    </div>
                </div>
            </div>
            <div class="column">
                <div class="field">
                    <label for="" class="label">Apartamento</label>
                    <div class="control has-icons-left">
                        <span class="icon"><i class="fas fa-building"></i></span>
                        <input bind:value={delivery.apartment} type="text" class="input" placeholder="Apartamento">
                    </div>
                </div>
            </div>
        </div>
        <div class="columns">
            <div class="column">
                <div class="field">
                    <label for="" class="label">Referencias</label>
                    <div class="control has-icons-left">
                        <span class="icon"><i class="fas fa-asterisk"></i></span>
                        <input bind:value={delivery.references} type="text" class="input" placeholder="Referencias" required>
                    </div>
                </div>
            </div>
        </div>
        <div class="items-end">
            {#if $orderLinkStore.quotation === 'user'}
                <button type="submit" class="button is-primary">
                    <span class="icon"><i class="fas fa-save"></i></span>
                    <span>Guardar</span>
                </button>
                {:else}
                    <button type="submit" class="button is-primary">
                        <span class="icon"><i class="fas fa-truck"></i></span>
                        <span>Cotizar</span>
                    </button>
            {/if}
        </div>
    </form>
{/if}